import { Box } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import type { SlashCommand } from './slashCommands';

// Match the mention suggestions popup so both composer overlays read the same.
const POPUP_WIDTH = 430;

interface SlashCommandPopoverProps {
  matches: SlashCommand[];
  activeIndex: number;
  onHover: (_index: number) => void;
  onSelect: (_cmd: string) => void;
}

// The highlighted row tracks activeIndex (keyboard) and mouse hover; click
// and Enter/Tab both complete through onSelect.
export const SlashCommandPopover = ({
  matches,
  activeIndex,
  onHover,
  onSelect,
}: SlashCommandPopoverProps) => (
  <Box
    w="100%"
    maxW={`${POPUP_WIDTH}px`}
    border="1px solid"
    borderColor="border-color"
    borderRadius="10px"
    bg="base-white"
    mb="6px"
    overflow="hidden"
    boxShadow="0px 8px 24px rgba(38, 34, 68, 0.10)"
    data-test-id="composer-slash-popover"
  >
    {matches.map((c, i) => (
      <Box
        key={c.cmd}
        px="12px"
        py="7px"
        cursor="pointer"
        bg={i === activeIndex ? 'secondary-50' : undefined}
        _hover={{ bg: 'secondary-50' }}
        onMouseEnter={() => onHover(i)}
        onClick={() => onSelect(c.cmd)}
        data-test-id={`composer-slash-${c.cmd.slice(1)}`}
        data-active={i === activeIndex || undefined}
      >
        <Text variant="h4">
          {c.cmd}{' '}
          <Text as="span" className="text-secondary-500">
            {c.args}
          </Text>
        </Text>
        <Text variant="p" style={{ display: 'block' }}>
          {c.hint}
        </Text>
      </Box>
    ))}
  </Box>
);
